import React from "react";
import ContactUsForm from '../components/ContactUsForm/index';
import './ContactUs.scss';


const ContactUs = () => {

  
  return (
    <main>
      <div className="winery-header">
      </div>
      <div className="winery-container contactus-container">
        <div className="left-side">
          {/* <p>
            Please visit our{" "}
            <a href="" className="text-link">
              FAQ Page
            </a>{" "}
            for answers to most of your questions.
          </p> */}
          <br/>
          <div>
            <p>
              <strong>General Inquiries:</strong> support@itsmywine.com
            </p>
            <p>
              <strong>Wholesale Inquiries:</strong> wholesale@itsmywine.com
            </p>
          </div>
          <br/>
          <div>
            <p className="">
              <strong></strong>Phone: (
              <a href="tel:(347)%20565-0343" className="text-link">
                347) 565-0343
              </a>
              &nbsp; Our customer service team is currently working from home.
              The best way to reach us is via email at hello@itsmywine.com or
              use the contact form to the right!
            </p>
          </div>
          <div>
          <br/>
            <div>
              <strong className="wholesale-title">WHOLESALE</strong>
            </div>
            <div>
              Please fill out our{" "}
              <a
                href="https://goo.gl/forms/ssabRbC316oTAiJ13"
                className="text-link"
              >
                Stockist Application Form
              </a>{" "}
              to gain access to our wholesale shop. If we think you're a good
              fit, we will reach out with login info!
            </div>
          </div>
        </div>
        <div className="contactUsForm">

        <ContactUsForm />
        </div>
      </div>
    </main>
  );
};

export default ContactUs;
